import React from "react";
import { connect } from "react-redux";
import { batch } from "react-redux";
import { bindActionCreators } from "redux";
// MUI Components
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import WarningIcon from "@material-ui/icons/Warning";

// Other Files
import { colors } from "../../constants/colors";
import { customTheme } from "../../constants/customTheme";
import classNames from "classnames";

import { toggleLock, toggleLockDialog, fetchCloseDevice } from "../../actions";

const useStyles = makeStyles({
  root: (props) => customTheme(props.theme).dialog.root,
  title: customTheme().dialog.title,
  contentContainer: customTheme().dialog.contentContainer,
  contentItem: customTheme().dialog.contentItem,
  buttonContainer: customTheme().dialog.buttonContainer,
  titleIcon: {
    color: colors.warning,
    ...customTheme().titleIcon,
  },
  buttonPrimary: (props) => customTheme(props.theme).buttonPrimary,
  buttonOutlined: (props) => customTheme(props.theme).buttonOutlined,
});

const LockStudyDialog = (props) => {
  const classes = useStyles(props);

  function handleLockStudy() {
    //called when switching study to LOCK state
    batch(() => {
      props.toggleLock();
      // props.toggleLockDialog();
      if (props.connectionEstablished) {
        props.fetchCloseDevice("LOCKING"); // fetchCloseDevice needs a prompt input. As long as the prompt is not QUIT it will toggle AcquireBar
      }
      props.onClose();
    });
  }

  function handleUnlockStudy() {
    //called when switching study to UNLOCK state
    batch(() => {
      props.toggleLock();
      props.onClose();
    });
  }

  if (!props.locked) {
    return (
      <Dialog
        open={props.open}
        PaperProps={{ className: classNames(classes.root) }}
      >
        <Typography
          className={classes.title}
          variant="h4"
          color="textPrimary"
          align="center"
        >
          <WarningIcon className={classes.titleIcon} />
          <span>Locking Study</span>
        </Typography>
        <DialogContent className={classes.contentContainer}>
          <Typography
            className={classes.contentItem}
            color="textPrimary"
            align="center"
          >
            Locking a study will put it in "read-only" mode. Are you sure you
            want to lock this study?
          </Typography>
        </DialogContent>

        <DialogActions className={classes.buttonContainer}>
          <Button
            onClick={props.onClose}
            variant="outlined"
            className={classes.buttonOutlined}
          >
            Cancel
          </Button>
          <Button
            onClick={handleLockStudy} // change the lock state of redux
            className={classes.buttonPrimary}
            variant="contained"
            color="primary"
          >
            Lock Study
          </Button>
        </DialogActions>
      </Dialog>
    );
  } else if (props.allDataLocal) {
    return (
      <Dialog
        open={props.open}
        PaperProps={{ className: classNames(classes.root) }}
      >
        <Typography
          className={classes.title}
          variant="h4"
          color="textPrimary"
          align="center"
        >
          <WarningIcon className={classes.titleIcon} />
          <span>Unlocking Study</span>
        </Typography>
        <DialogContent className={classes.contentContainer}>
          <Typography
            className={classes.contentItem}
            color="textPrimary"
            align="center"
          >
            Unlocking a locked study may impact previous reports generated for
            the study. Are you sure you want to unlock this study?
          </Typography>
        </DialogContent>

        <DialogActions className={classes.buttonContainer}>
          <Button
            onClick={props.onClose}
            variant="outlined"
            className={classes.buttonOutlined}
          >
            Cancel
          </Button>
          <Button
            onClick={handleUnlockStudy} // change the lock state of redux, set the protocol on the back-end
            className={classes.buttonPrimary}
            variant="contained"
            color="primary"
          >
            Unlock Study
          </Button>
        </DialogActions>
      </Dialog>
    );
  } else {
    return (
      <Dialog
        open={props.open}
        PaperProps={{ className: classNames(classes.root) }}
      >
        <Typography
          className={classes.title}
          variant="h4"
          color="textPrimary"
          align="center"
        >
          <WarningIcon className={classes.titleIcon} />
          Study Data Unavailable
        </Typography>
        <DialogContent className={classes.contentContainer}>
          <Typography
            className={classes.contentItem}
            color="textPrimary"
            align="center"
          >
            This study cannot be unlocked because the sample data is not all
            available locally.
          </Typography>
        </DialogContent>

        <DialogActions className={classes.buttonContainer}>
          <Button
            onClick={() => props.onClose()}
            variant="contained"
            color="primary"
            className={classes.buttonPrimary}
          >
            Okay
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      toggleLock,
      toggleLockDialog,
      fetchCloseDevice,
    },
    dispatch
  );
};

const mapStateToProps = (state) => {
  return {
    allDataLocal: state.studyInfo.allDataLocal,
    locked: state.studyInfo.locked,
    connectionEstablished: state.device.connectionEstablished,
    theme: state.utility.theme,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LockStudyDialog);
